import React from "react";
import CoachesPage from "@/pages/CoachesPage";

/**
 * Dozenten-Bereich: dedicated management page for Weiterbildung lecturers.
 * Reuses CoachesPage in "lecturers" mode — filters + creates users with role="lecturer".
 */
export default function DozentenPage() {
  return <CoachesPage mode="lecturers" />;
}
